var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmarkBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7516 1.17995C16.0539 1.44445 16.0845 1.90391 15.82 2.20619L5.63823 13.8426C5.50569 13.994 5.31628 14.0838 5.11511 14.0905C4.91393 14.0972 4.71898 14.0202 4.57665 13.8779L0.213013 9.51426C-0.0710044 9.23025 -0.0710044 8.76976 0.213013 8.48575C0.497031 8.20173 0.957514 8.20173 1.24153 8.48575L5.05548 12.2997L14.7254 1.24837C14.9899 0.946089 15.4493 0.915458 15.7516 1.17995Z",
    fill: "#020409"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkBlack);
export default __webpack_public_path__ + "static/media/checkmarkBlack.b92a465a874f0b29c9aaac21a91a90e2.svg";
export { ForwardRef as ReactComponent };